module.exports = __webpack_public_path__ + "static/img/chart5.684121c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart5.png
// module id = cqHi
// module chunks = 1